import callApi from "Common/utils/apiCaller";
import { showNotification } from "Common/utils/Notification";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ReactSelect from "../ReactSelect/ReactSelect";
import Button from "../ButtonComponent/Button";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import Drawer from "../Drawer";
import { X } from "lucide-react";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const PeopleSegments = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const [peopleList, setPeopleList] = useState<any>();
  const [people, setPeople] = useState<any>([]);
  const [headerText, setHeaderText] = useState<any>(data?.header_text);
  const [staticData, setStaticData] = useState<any>([]);
  const [subHeaderText, setSubHeaderText] = useState(data?.subheader_text);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>("");
  const [indexBack, setIndexBack] = useState(undefined);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setBackgroundImage(imageData.media_url);
          setBackgroundImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  const [errors, setErrors] = useState({
    people_list: "",
  });

  useEffect(() => {
    async function fetchData(params: string[]) {
      const arr: { label: string; value: string }[] = [];
      const arr1 = [];
      try {
        for (const item of params) {
          const localData = await callApi(`v1/people/${item}`, "get", {});
          if (localData?.status === "Success") {
            arr.push({
              label: localData?.data?.people?.name,
              value: localData?.data?.people?._id,
            });
            arr1.push(localData?.data?.people?._id);
          }
        }
        setStaticData(arr);
        setPeople(arr1);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    if (data?.people_list?.length !== 0 && Array.isArray(data.people_list)) {
      fetchData(data.people_list);
    }
  }, [data?.people_list]);

  useEffect(() => {
    fetchPeopleList();
  }, []);
  const fetchPeopleList = async () => {
    const localData = await callApi("v1/people/list", "post", {
      pageNum: 1,
      pageSize: 1000,
      filters: {},
    });

    if (localData?.status === "Success") {
      setPeopleList([
        ...localData.data.peopleList.map((item, i) => ({
          label: item?.name,
          value: item?._id,
        })),
      ]);
    }
  };
  const handlePeopleData = (keyName, keyValue) => {
    let arr = [];
    for (let item of keyValue) {
      arr.push(item.value);
    }
    setPeople(arr);
    setStaticData(keyValue);
    setErrors((prev) => ({ ...prev, [keyName]: "" }));
  };
  const handleSave = async (pageId, id) => {
    const newErrors = {
      people_list: people?.length === 0 ? "Please select people." : "",
    };

    setErrors(newErrors);
    if (people.length === 0) {
      return;
    }
    const payload = {
      segment_type: "people_segments",
      people_list: people,
      header_text: headerText,
      subheader_text: subHeaderText,
      

      background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground
    };

    try {
      setIsLoading(true);
      const response = await callApi(
        `v1/page/${pageId}/segment/${id}/update-info`,
        "post",
        payload
      );
      setIsLoading(false);
      if (response && response?.status === "Success") {
        setLoader(!loader);
        showNotification("People segment added successfully!", "success");
      }
    } catch (e) {
      showNotification("An error occurred . Please try again.", "error");
      setIsLoading(false);
    }
  };

  const getPeopleFromVersionData = (people_list) => {
    let newPeople = [];
    peopleList?.forEach((item) => {
      people_list?.forEach((peopleId) => {
        if (item.value === peopleId) {
          newPeople.push(item);
        }
      });
    });
    return newPeople;
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div>
          <ToggleSwitch
            selectValue={data?.is_visible}
            versionValue={versionData?.is_visible}
            toggle={() =>
              toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
            }
            label="Is Segment Visible?"
            required={true}
          />
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setImageData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();

                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();

                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Top Header Text"
            value={headerText}
            onChange={(e) => {
              // setErrors((prev) => ({
              //   ...prev,
              //   ["header_text"]: "",
              // }));
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
            error={null}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Sub Header Text"
            name="subHeaderText"
            type="text"
            placeholder="Enter Sub Header Text"
            value={subHeaderText}
            onChange={(e) => {
              // setErrors((prev) => ({
              //   ...prev,
              //   ["header_text"]: "",
              // }));
              setSubHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.subheader_text}
            error={null}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <label className="inline-block mb-2 text-base font-medium">
            Select People List
          </label>
          <ReactSelect
            options={peopleList}
            isSearchable={true}
            isMulti={true}
            placeholder={"Please select people list"}
            contentType={staticData}
            handleContentChange={handlePeopleData}
            name={"people_list"}
            id={"people-list9"}
            versionData={getPeopleFromVersionData(versionData?.people_list)}
          />
          {errors.people_list && (
            <p className="text-red-500">{errors.people_list}</p>
          )}
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default PeopleSegments;
